import React from "react"
import Header from "./Header"
import Introduction from "./Introduction"
import Skill from "./Skill"
import Project from "./Project"
import Footer from "./Footer"
function App(){
    return(

    <div>
       <Header />
       <Introduction />
       <Skill />
       <Project />
       <Footer />
    </div> 
    
    )
}

export default App